import { render, staticRenderFns } from "./channelCommission.vue?vue&type=template&id=7d90118f&scoped=true"
import script from "./channelCommission.vue?vue&type=script&lang=js"
export * from "./channelCommission.vue?vue&type=script&lang=js"
import style0 from "./channelCommission.vue?vue&type=style&index=0&id=7d90118f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d90118f",
  null
  
)

export default component.exports